import { Typography } from '@/components/common';
import { segmentationDefinition } from '@/const';
import * as React from 'react';

export const SegmentationContentTooltip = () => {
	return (
		<ul className="list-decimal pl-4 font-semibold text-xs">
			{segmentationDefinition.map((item) => (
				<li key={item.title}>
					{item.title === 'Disengaged Customer' ? (
						<>
							<Typography type="regular-12">
								<span className="font-semibold">{item.title}:</span>{' '}
							</Typography>
							<ul className="list-disc pl-1.5">
								<li>
									<Typography type="regular-12" className="!leading-[150%]">
										Clients whose cases are on hold or canceled.
									</Typography>
								</li>
								<li>
									<Typography type="regular-12" className="!leading-[150%]">
										Clients who registered but didn’t apply for any cases within
										their first six months.
									</Typography>
								</li>
								<li>
									<Typography type="regular-12" className="!leading-[150%]">
										Clients who reactivated their account after previously
										deleting it.
									</Typography>
								</li>
							</ul>
						</>
					) : (
						<Typography type="regular-12" className="!leading-[150%]">
							<span className="font-semibold">{item.title}:</span>{' '}
							{item.content}
						</Typography>
					)}
				</li>
			))}
		</ul>
	);
};
